import React,{Component} from 'react';
import Paper from 'material-ui/Paper';
import { FormControl } from 'material-ui/Form';
import Button from 'material-ui/Button';
import TextField from 'material-ui/TextField';
import Grid from 'material-ui/Grid';
import {getJSON} from 'jquery'
class SearchBox extends Component{
    constructor(){
        super();
        this.state={
            key:''
        }
    }


    handleClick(key,event){

        getJSON('http://123.207.90.121:8080/newBlog/api/getBlogsByKey',{key:key}).then(response=>{
            const data=response.data;
            if (response.code>=1){
                this.props.handleBlogArray(data);
                console.log("加载typeBlog成功"+data.length)
            }else {
                this.props.handleBlogArray([]);
                console.log("加载typeBlog失败")
            }
            this.setState({load:false})
        },error=> {
            this.setState({load:false})
        })

    }

    handleChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({[name]: event.target.value});
        console.log(this.state)
    }


    render(){
        return(
/*'linear-gradient(to right, rgba(255,91,91), rgba(225,162,138)'*/
            <Paper style={{background:'white'}}>
                <table align="center" valign="medium">
                    <tbody>
                    <tr>
                        <td>
                            <div>
                                <Grid container spacing={8} alignItems="flex-end">
                                    <Grid item>
                                        <TextField value={this.state.key} name="key" onChange={this.handleChange.bind(this)} label="Search Someting" />
                                    </Grid>
                                </Grid>
                            </div>

                        </td>
                        <td valign="right">
                            <FormControl>
                                <Button style={{backgroundColor:'#fffdf4'}} onClick={this.handleClick.bind(this,this.state.key)} variant="fab" aria-label="edit" >
                                    <i className="material-icons">search</i>
                                </Button>
                            </FormControl>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </Paper>
        )
    }
}
export default SearchBox;


// WEBPACK FOOTER //
// ./src/Compent/page/SearchBox.js